<template>

  <div class="vz-tab-bar" :class="{ 'vz-steps-mode': stepsMode }">
    <div class="vz-tab-bar-content">
      <ul class="vz-tab-bar-list">
        <li class="vz-tab-bar-list-item"
            v-for="item in tabs"
            :class="[ item.cssClass || '', { 'vz-active': current === item, 'vz-disabled': item.disabled, 'vz-hide': item.hide }]"
            @click="select(item)">
          <span class="vz-tab-bar-list-item-label" v-html='item.label'></span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import Base from '../vz-base.vue';

/**
 * Tab bar.
 * @module VzTabsBar
 * @param {Array} tabs List of objects { label: String, value: *, disabled: Boolean }.
 * @param {*} value Value of active tab.
 * @emits {Event} change
 * @author Lanza
 */
export default {

  name: 'VzTabsBar',
  extends: Base,
  emits: ['change'],

  props: {
    tabs: {
      type: Array,
      default: []   // [{ label: String, value: *, disabled: Boolean, hide: Boolean, cssClass: String }]
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    stepsMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {

    current: function () {
      return this.tabs.find(tab => tab.value === this.value) || null;
    }

  },

  methods: {

    select: function (tab) {
      if(!(tab.disabled || tab === this.current)) {
        this.$emit('change', tab.value);
      }
    }

  }

}
</script>

<style>

.vz-tab-bar-content {
  width: 100%;
  display: flex;
  justify-content: center;
}

.vz-tab-bar-list {
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: flex-end;
}

.vz-tab-bar-list-item {
  display: block;
  cursor: pointer;
  white-space: nowrap;
  padding: 12px 16px;
  border-bottom-style: solid;
  border-bottom-width: 4px;
  border-bottom-color: rgba(0,0,0,0);
  line-height: 1em;
}

.vz-tab-bar-list-item.vz-active {
  border-bottom-color: var(--primary-color);
  cursor: default;
}

.vz-tab-bar-list-item.vz-disabled {
  cursor: default;
  opacity: 0.75;
}
.vz-tab-bar-list-item.vz-hide{
  display: none !important;
}
.vz-steps-mode .vz-tab-bar-list-item:before {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 1em;
  width: 24px;
  height: 24px;
  border-radius: 32px;
  background-color: var(--primary-color);
  text-align: center;
  font-size: 14px;
}

.vz-tab-bar-list-item.vz-active:before,
.vz-tab-bar-list-item.vz-disabled:before
{
  background-color: transparent;
}

.vz-tab-bar-list-item.vz-active:before {
  color: var(--primary-color-active);
  font-weight: bold;
}

.vz-steps-mode .vz-tab-bar-list-item:first-child:before {
  content: '1';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(2):before {
  content: '2';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(3):before {
  content: '3';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(4):before {
  content: '4';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(5):before {
  content: '5';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(6):before {
  content: '6';
}

.vz-steps-mode .vz-tab-bar-list-item:nth-child(7):before {
  content: '7';
}

.vz-tab-bar-list-item > span {
  font-size: 0.775em;
  text-transform: uppercase;
}

.vz-tab-bar-list-item.vz-active > span {
  font-weight: bold;
  color: var(--primary-color-active);
}

.vz-steps-mode .vz-tab-bar-list-item > span {
  display: none;
}

@media (min-width: 1024px) {

  .vz-steps-mode .vz-tab-bar-list-item:before {
    display: none;
  }

  .vz-tab-bar-list-item {
    padding: 12px 32px;
  }

  .vz-steps-mode .vz-tab-bar-list-item > span {
    display: block;
  }



}

</style>
